// extracted by mini-css-extract-plugin
export default {"main_content":"Main_main_content__n0uzQ","main":"Main_main__F2ek1"};